import React, { useState, useEffect } from 'react';
import {
    Text, View, StyleSheet,
    TextInput
} from 'react-native';

import * as CommonUtils from '../../utils/services/CommonUtils';
import AppTheme from '../../AppTheme';
import AppStyles from '../../AppStyles';
import { CommonHeader } from '../../utils/widgets/CommonWidget/CommonHeader';
import OmsStyles from '../../OmsStyle';
import { IndiaRupee } from '../../utils/constants/AppConstants';
import { CommonCTA } from '../../utils/widgets/CommonCTA';

const EnterDebitCreditDetails = (props) => {

    const [number, setCardNumber] = useState('');
    const [name, setname] = useState('');
    const [realCardNumber, setRealCardNumber] = useState('');

    const [expiry_month, setCardValidityMM] = useState('');
    const [expiry_year, setCardValidityYY] = useState('');

    const [cvv, setCvv] = useState('');
    const [payableAmount, setPayableAmount] = useState(props.route?.params?.payableAmount)

    useEffect(() => {
        // setNetBankingModes(props.route.params.netBankingModes);
    }, []);

    function continueSaveCardDetails() {
        props.route.params.updateCardDetailsAndPay({ number: realCardNumber, method: 'card', name, expiry_month, expiry_year, cvv });
        global.appHandledBackpress = true;
        props.navigation.pop();
    }

    function encodeAndConvertCardNumber(text) {
        if (number.length > 0 && number.length > text.length) {
            setRealCardNumber(realCardNumber.slice(0, -1));
            setCardNumber(number.slice(0, -1));
        } else {
            // setRealCardNumber(realCardNumber + text.slice(-1));
            let strArr: any = 'X'.repeat((realCardNumber + text.slice(-1)).length).match(/.{1,4}/g);
            let parsedText = strArr.join(' ');
            setCardNumber(parsedText);
            setRealCardNumber(realCardNumber + text.slice(-1));
        }
    }

    return (
        <View style={{ flex: 1, width: AppTheme.appWidth, position: 'relative', height: '100%', minHeight: '100vh' }}>
            <CommonHeader navigation={props.navigation} title={`Add New Card`} allowPopScreen={true}></CommonHeader>

            <View style={{ marginTop: AppTheme.headerHeight, padding: 16, paddingTop: 17 }}>
                <View style={{ position: 'relative' }}>
                    {number.length > 0 ? <Text style={styles.placeHolderLabel}>Card Number</Text> : null}
                    <TextInput autoCompleteType='off'
                        style={[OmsStyles.text14, styles.grayText, styles.textInput, { marginTop: 0 }]}
                        placeholderTextColor={AppTheme.color.fillerInfo}
                        placeholder="Card Number" underlineColorAndroid="transparent"
                        maxLength={19} value={number}
                        keyboardType={'numeric'}
                        onChangeText={(text) => encodeAndConvertCardNumber(text)} />

                </View>

                <View style={{ position: 'relative' }}>
                    {name.length ? <Text style={[styles.placeHolderLabel, { top: 6 }]}>Card Holder Name</Text> : null}
                    <TextInput autoCompleteType='off'
                        style={[OmsStyles.text14, styles.grayText, styles.textInput]}
                        placeholderTextColor={AppTheme.color.fillerInfo}
                        placeholder="Card Holder Name" underlineColorAndroid="transparent"
                        maxLength={80} value={name}
                        onChangeText={(text) => setname(text.toUpperCase())} />
                </View>

                <View style={[AppStyles.flexRow]}>
                    <View style={[styles.textInput, AppStyles.flexRow, { marginRight: 8, position: 'relative', width: (AppTheme.appWidth * 0.57) - 64 }]}>

                        {expiry_year.length ? <Text style={styles.placeHolderLabel}>Validity</Text> : null}

                        <TextInput autoCompleteType='off'
                            style={[OmsStyles.text14, styles.grayText, { width: 18 }]}
                            placeholderTextColor={AppTheme.color.fillerInfo}
                            placeholder="YY" underlineColorAndroid="transparent"
                            maxLength={2} value={expiry_year}
                            keyboardType='numeric'
                            onChangeText={(text) => setCardValidityYY(text.toUpperCase())} />/

                        <TextInput keyboardType='numeric' autoCompleteType='off'
                            style={[OmsStyles.text14, styles.grayText, { width: 30, paddingLeft: 3 }]}
                            placeholderTextColor={AppTheme.color.fillerInfo}
                            placeholder="MM" underlineColorAndroid="transparent"
                            maxLength={2} value={expiry_month}
                            onChangeText={(text) => setCardValidityMM(text.toUpperCase())} />
                    </View>

                    <View style={{ position: 'relative' }}>
                        {cvv.length ? <Text style={[styles.placeHolderLabel, { top: 6, left: 19 }]}>CVV</Text> : null}
                        <TextInput autoCompleteType='off'
                            style={[OmsStyles.text14, styles.grayText, styles.textInput, { marginLeft: 8, width: (AppTheme.appWidth * 0.57) - 32 }]}
                            placeholderTextColor={AppTheme.color.fillerInfo}
                            keyboardType={'numeric'} placeholder="CVV"
                            underlineColorAndroid="transparent"
                            maxLength={3}
                            secureTextEntry={true}
                            value={cvv}
                            onChangeText={(text) => setCvv(text.toUpperCase())} />
                    </View>

                </View>
            </View>

            <View style={[AppStyles.submitBtn, { bottom: 60, position: 'absolute', marginLeft: 16 }]}>
                <CommonCTA
                    type={'fill'}
                    text={`Pay ${IndiaRupee}${payableAmount}`}
                    marginVertial={24}
                    onPress={() => { continueSaveCardDetails() }}
                    width={AppTheme.appWidth - 32}
                    disabled={number.length !== 19 ||
                        (cvv).toString().length !== 3 || name.length < 3 ||
                        expiry_year.length !== 2 || expiry_month.length !== 2} />
            </View>
        </View >
    )
}

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({

    placeHolderLabel: { fontSize: 12, color: 'rgba(0, 0, 0, 0.38)', position: 'absolute', top: -8, left: 11, paddingHorizontal: 4, backgroundColor: 'white' },
    container: {
        flex: 1,
    },
    textInput: { marginTop: 16, width: AppTheme.appWidth - 32, borderColor: '#4F4F4F', borderWidth: 1, borderRadius: 8, paddingVertical: 10, paddingHorizontal: 16, color: 'black', },

    hr: {
        backgroundColor: 'rgba(235, 235, 235, 1)',
        height: 2,
        position: 'relative',
        left: -17,
        width: '100vw',
        marginVertical: 16
    },
    subTitle: {
        fontWeight: 600,
        fontSize: 14,
        lineHeight: 16,
        color: '#000000',
        paddingBottom: 5
    },
    modesTitle: {
        fontSize: 16,
        fontWeight: '700',
        lineHeight: 19,
        letterSpacing: 0,
        textAlign: 'left',
        paddingBottom: 16

    },
    checkbox: {
        // alignSelf: "center",
        margin: 10,
        // backgroundColor: AppTheme.color.primary,
        height: 18,
        width: 18,
        borderWidth: 1,
        borderColor: 'rgba(0, 0, 0, 0.38)'
    },

    grayText: {
        fontSize: 14,
        color: '#4F4F4F'
    },


}))

export default EnterDebitCreditDetails;